import { apiClient } from '@/lib/apiClient';

const get = async (path, options) => {
  const { data, error } = await apiClient.GET(path, options);
  if (error) throw error;
  return data;
};

export const getCommodities = () => get('/api/v1/traceability/commodities');

export const getDashboard = (commodity) =>
  get(`/api/v1/traceability/dashboard/${commodity}`);

export const getTraceabilityGraph = (commodity, chainId) =>
  get(`/api/v1/traceability/graph/${encodeURIComponent(commodity)}/${encodeURIComponent(chainId)}`);

export const getImports = (filters) =>
  get('/api/v1/traceability/imports', {
    params: { query: filters },
  });

export const getBalance = (filters) =>
  get('/api/v1/traceability/balance', {
    params: { query: filters },
  });

export const getGeoSummary = (filters) =>
  get('/api/v1/traceability/geo/summary', {
    params: { query: filters },
  });

export const getGeoHeatmap = (filters) =>
  get('/api/v1/traceability/geo/heatmap', {
    params: { query: filters },
  });

export const getGeoCities = (filters) =>
  get('/api/v1/traceability/geo/cities', {
    params: { query: filters },
  });
